<script lang="ts">
  import { type Snippet } from 'svelte';

  import ErrorView from '$shared/organisms/ErrorView/ErrorView.svelte';
  import Title from './partials/Title.svelte';
  import Container from './partials/Container.svelte';
  import Header from './partials/Header.svelte';
  import Content from './partials/Content.svelte';
  import type { ReviewTemplateOption } from '$shared/components/types';

  interface Props {
    loading?: boolean;
    processing?: boolean;
    disabled?: boolean;
    option: ReviewTemplateOption;
    leftActions?: Snippet | undefined;
    feedbackAction?: Snippet | undefined;
    alertSlot?: Snippet | undefined;
    actions?: Snippet | undefined;
    children?: Snippet | undefined;
    oncloseerror?: () => void;
    oncancel?: () => void;
    onok?: () => void;
    onclick?: (e: MouseEvent) => void;
    onclickinfoalert?: () => void;
  }

  let {
    loading = false,
    processing = false,
    disabled = false,
    option,
    leftActions = undefined,
    feedbackAction = undefined,
    alertSlot = undefined,
    actions = undefined,
    children = undefined,
    oncloseerror,
    oncancel,
    onok,
    onclick,
    onclickinfoalert
  }: Props = $props();

  let containerElement: Container = $state();

  const onCloseError = (): void => {
    oncloseerror?.();
  };

  export const scrollToError = () => {
    containerElement?.scrollIntoView();
  };
</script>

<div data-cy={`${option?.name}-review`} class="comp-review-template">
  {#if option}
    <!-- Header -->
    <Header
      loading={processing}
      {disabled}
      name={option.name}
      okLabel={option.okLabel}
      cancelLabel={option.cancelLabel}
      hideAction={option.hideAction}
      hasCustomAction={option.hasCustomAction}
      hideCancel={option?.hideCancel}
      {leftActions}
      {feedbackAction}
      actions={actionsContent}
      {oncancel}
      {onok}
    >
      <Title
        name={option.name}
        title={option.title}
        type={option.type}
        style={option.titleStyle}
        {onclick}
      />
    </Header>
    <!-- Header -->

    <!-- Container -->
    {#snippet actionsContent()}
      <div class="actions-content" class:show={option.hasCustomAction}>
        {@render actions?.()}
      </div>
    {/snippet}
    {#snippet alertSlotContent()}
      <div class="alert" class:has-alert={!!alertSlot}>
        {@render alertSlot?.()}
      </div>
    {/snippet}
    <Container bind:this={containerElement} error={option.error} alertSlot={alertSlotContent} onclose={onCloseError}>
      <Content
        {loading}
        name={option?.name}
        bannerInfo={option?.bannerInfo}
        nonReviewable={option?.nonReviewable}
        infoAlertLabel={option?.infoAlertLabel}
        onclickInfoAlert={onclickinfoalert}
        {children}
      />
    </Container>
    <!-- Container -->
  {:else}
    <div class="invalid">
      <ErrorView label={'Invalid props passed to the Review Template'} />
    </div>
  {/if}
</div>

<style>
  .comp-review-template {
    width: 100vw;
    height: 100vh;
    padding-top: 56px;
    position: relative;
    overflow: hidden;
  }
  .actions-content {
    display: none;
  }
  .actions-content.show {
    display: block;
  }
  .alert {
    display: none;
  }
  .alert.has-alert {
    grid-column: 1 / span 12;
    display: block;
  }

  .invalid {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 50%;
  }
</style>
